import { useRemoteConfig } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

type LegalInfo = { id: 'agreement'; link: string };

const { legalLink: defaultLegalLink } = clientConfig;

export const useLegal = () => {
    const remoteConfig = useRemoteConfig();

    const legal = remoteConfig.flags.get('legal') as LegalInfo[] | undefined;

    return legal?.find((entry) => entry.id === 'agreement')?.link ?? defaultLegalLink;
};
